// extracted by mini-css-extract-plugin
export default {"mainContainer":"contacts_mainContainer_Tt_ri","contact":"contacts_contact_bj_mC","contactInfo":"contacts_contactInfo_sQK3t"};